import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";

/**
 * ImpersonationBanner — persistente y a propósito NADA discreto (a diferencia
 * del logo de academia): un PLATFORM_ADMIN viendo la app como otra persona
 * debe saberlo en todo momento, para no confundir sus acciones con las del
 * owner real. Vive en el mismo slot que SubscriptionBanner (app-main, arriba
 * del contenido) pero se monta para TODOS los roles — la impersonación no es
 * un aviso de tenant, es un estado de la sesión del propio staff.
 */
function ImpersonationBanner() {
  const { impersonation, endImpersonation } = useAuth();
  const navigate = useNavigate();
  const [ending, setEnding] = useState(false);

  if (!impersonation) return null;

  async function handleEnd() {
    setEnding(true);
    try {
      await endImpersonation();
      navigate("/superadmin/academias");
    } catch {
      // La cookie de refresh del staff pudo vencer entretanto — igual lo
      // manda al login en vez de dejarlo atascado en una sesión a medias.
      navigate("/login");
    } finally {
      setEnding(false);
    }
  }

  return (
    <div
      className="alert alert-dark border-0 rounded-0 mb-0 d-flex flex-wrap align-items-center justify-content-between gap-2 px-3 py-2"
      role="alert"
    >
      <span>
        <i className="mdi mdi-account-switch-outline me-2" aria-hidden="true" />
        Estás viendo <strong>{impersonation.company?.name ?? "esta academia"}</strong>{" "}
        como su propietario.
      </span>
      <button
        type="button"
        className="btn btn-sm btn-light fw-semibold flex-shrink-0"
        onClick={handleEnd}
        disabled={ending}
        style={{ minHeight: 44 }}
      >
        {ending ? "Saliendo…" : "Salir de impersonación"}
      </button>
    </div>
  );
}

export { ImpersonationBanner };
